var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 142,
    viewBox: "0 0 400 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M199.874 20.4991C199.874 20.4991 194.21 18.8293 193 13.152C193 13.152 201.753 11.2373 202 21L199.874 20.4991Z",
    fill: "#0D9F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M200.618 18.9847C200.618 18.9847 197.263 12.7929 200.216 7C200.216 7 205.868 11.1977 203.357 19L200.618 18.9847Z",
    fill: "#0D9F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201 18.979C201 18.979 203.426 12.2695 210.867 11C210.867 11 212.256 15.3541 206.058 19L201 18.979Z",
    fill: "#0D9F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198 19L199.092 25.9725L205.981 26L207 19.0367L198 19Z",
    fill: "#24285B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M210 134C250.317 134 283 129.523 283 124C283 118.477 250.317 114 210 114C169.683 114 137 118.477 137 124C137 129.523 169.683 134 210 134Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222 31H165V127H222V31Z",
    fill: "#24285B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M213.33 37H174.67C172.091 37 170 38.9098 170 41.2657V46.7343C170 49.0902 172.091 51 174.67 51H213.33C215.909 51 218 49.0902 218 46.7343V41.2657C218 38.9098 215.909 37 213.33 37Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208 26H179V31H208V26Z",
    fill: "#0D9F3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209 49C211.209 49 213 47.2091 213 45C213 42.7909 211.209 41 209 41C206.791 41 205 42.7909 205 45C205 47.2091 206.791 49 209 49Z",
    fill: "#0D9F3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M199 42H175V46H199V42Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M213.33 59H174.67C172.091 59 170 61.1826 170 63.875V70.125C170 72.8174 172.091 75 174.67 75H213.33C215.909 75 218 72.8174 218 70.125V63.875C218 61.1826 215.909 59 213.33 59Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209 72C211.209 72 213 70.2091 213 68C213 65.7909 211.209 64 209 64C206.791 64 205 65.7909 205 68C205 70.2091 206.791 72 209 72Z",
    fill: "#0D9F3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199 66H175V70H199V66Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M213.33 83H174.67C172.091 83 170 85.1826 170 87.875V94.125C170 96.8174 172.091 99 174.67 99H213.33C215.909 99 218 96.8174 218 94.125V87.875C218 85.1826 215.909 83 213.33 83Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M209 95C211.209 95 213 92.9853 213 90.5C213 88.0147 211.209 86 209 86C206.791 86 205 88.0147 205 90.5C205 92.9853 206.791 95 209 95Z",
    fill: "#0D9F3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M199 88H175V92H199V88Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M213.33 106H174.67C172.091 106 170 108.183 170 110.875V117.125C170 119.817 172.091 122 174.67 122H213.33C215.909 122 218 119.817 218 117.125V110.875C218 108.183 215.909 106 213.33 106Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M209 118C211.209 118 213 116.209 213 114C213 111.791 211.209 110 209 110C206.791 110 205 111.791 205 114C205 116.209 206.791 118 209 118Z",
    fill: "#0D9F3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M199 112H175V115H199V112Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M239 102H234V127H239V102Z",
    fill: "#0D9F3F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M262 102H257V127H262V102Z",
    fill: "#0D9F3F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M239 102H234V127H239V102Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M262 102H257V127H262V102Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M267 91H229V104H267V91Z",
    fill: "#0D9F3F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M231 91L235.191 104H241L236.228 91H231Z",
    fill: "#24285B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M242 91L246.615 104H253L247.751 91H242Z",
    fill: "#24285B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M254 91L258.615 104H265L259.751 91H254Z",
    fill: "#24285B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M267 109H229V115H267V109Z",
    fill: "#0D9F3F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M267 109H229V115H267V109Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M154 60H122V97H154V60Z",
    fill: "#E6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M138.503 64L127 82H138.503H150L138.503 64Z",
    fill: "#FFD200"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M138 71H137V77H138V71Z",
    fill: "#24285B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M138 77H137V78H138V77Z",
    fill: "#24285B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M150 85H127V92H150V85Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedProcess);
export default __webpack_public_path__ + "static/media/failedProcess.78c1a0ccf6516b70364cabd90ee14dc5.svg";
export { ForwardRef as ReactComponent };